import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyAnu3ZvN9p1iJjsAx-f1DleqWRy0-6__J0",
  authDomain: "heyremote-6db3c.firebaseapp.com",
  databaseURL: "https://heyremote-6db3c.firebaseio.com",
  projectId: "heyremote-6db3c",
  storageBucket: "heyremote-6db3c.appspot.com",
  // messagingSenderId: "1093363666576",
  appId: "1:1093363666576:web:40dd132ed2749e04d15215"
};

firebase.initializeApp(firebaseConfig);

export default firebase;
